import {Button, ButtonGroup} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {GetSalePresetQualitySealImpactResponseBody} from '@dms/api/sales';
import i18n from '@dms/i18n';

type SetNewVehicleDialogProps = {
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  qualitySealImpact?: GetSalePresetQualitySealImpactResponseBody;
};

export function SetNewVehicleDialog({
  onCancel,
  onConfirm,
  isLoading,
  qualitySealImpact,
}: SetNewVehicleDialogProps) {
  return (
    <VStack spacing={1}>
      <Text>{i18n.t('entity.salePreset.setNewVehicleDialog.description')}</Text>
      <Show when={qualitySealImpact !== undefined}>
        <>
          <Text>
            {i18n.t('entity.qualitySeal.labels.impactEligibleVehicles', {
              count: qualitySealImpact?.eligibleVehicleCount ?? 0,
            })}
          </Text>
          <Text>
            {i18n.t('entity.qualitySeal.labels.impactManualVehicles', {
              count: qualitySealImpact?.manualVehicleCount ?? 0,
            })}
          </Text>
          <Text>{i18n.t('entity.qualitySeal.labels.impactPointInTime')}</Text>
        </>
      </Show>
      <ButtonGroup align="right">
        <Button
          data-testid="setVehicles-newWatermark-dialog-cancel"
          variant="secondary"
          onClick={() => {
            onCancel();
          }}
          isDisabled={isLoading}
          title={i18n.t('general.actions.cancel')}
        />
        <Button
          data-testid="setVehicles-newWatermark-dialog-confirm"
          variant="primary"
          onClick={() => {
            onConfirm();
          }}
          isLoading={isLoading}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </VStack>
  );
}
